import { gql } from "@apollo/client";

export const getRCAComplianceByMillCorporate = gql`
    query getRCAComplianceByMillCorporate(
        $args: get_rca_compliance_totals_by_mill_args!
        $where: rca_compliance_totals_by_mill_bool_exp
    ) {
        rca_compliance_by_mill: get_rca_compliance_totals_by_mill(where: $where, args: $args) {
            mill_id
            completed_on_time
            pending
            completed_late
            pending_late
            total_rcas_by_period
            mill {
                name
            }
        }
    }
`;

export const getActionPlanComplianceByMillCorporate = gql`
    query getActionPlanComplianceByMillCorporate(
        $args: get_action_plan_compliance_totals_by_mill_args!
        $where: action_plan_compliance_totals_by_mill_bool_exp
    ) {
        action_plan_compliance_by_mill: get_action_plan_compliance_totals_by_mill(where: $where, args: $args) {
            mill_id
            completed_on_time
            pending
            completed_late
            pending_late
            total_action_plans_by_period
            mill {
                name
            }
        }
    }
`;

export const getAvgActionPlansPerMill = gql`
    query getAvgActionPlansPerMill($args: get_avg_action_plans_per_mill_by_date_args!) {
        avg_action_plans_per_mill: get_avg_action_plans_per_mill_by_date(args: $args) {
            mill_id
            name
            average_action_plans_per_rca
            rca_without_action_plans
            rca_without_ap_list
        }
    }
`;

export const getRcaMethodologyUsedByMill = gql`
    query getRcaMethodologyUsedByMill($args: get_rca_methodology_used_by_mill_args!) {
        rca_methodology_used_by_mill: get_rca_methodology_used_by_mill(args: $args) {
            mill_id
            name
            total_rca
            fishbone_percentage
            five_why_percentage
            none_percentage
            none_methodology_rca_list
        }
    }
`;
